"use client";
import { useContext, useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import Slogan from "./slogan";
import ModalSearchCity from "../home/modals/ModalSearchCity";
import { useFindAllCommunities } from "@/api/traveler";
import LeftLandingImage from "@/assets/images/decorators/left-landing-image.webp";
import RightLandingDecorator from "@/assets/images/decorators/right-landing-decorator.webp";
import VeeRoadDecorator from "@/assets/images/decorators/vee-road-decorator.webp";
import Search from "@/assets/images/icons/search.svg";
import HexagonButton from "@/common/customElements/HexagonButton";
import SearchInputWithIcon from "@/common/customElements/SearchInputWithIcon";
import {
  AbsoluteDiv,
  CustomDiv,
  HomeHeaderDiv,
  HorizontalCenterDiv,
} from "@/common/divs";
import cities from "@/components/home/json/cities.json";
import SearchContext from "@/context/searchContext/searchContext";
import { useFixHydration } from "@/hooks/useFixHydration";
import { CityType, ModalProps, SearchContextType } from "@/types/components";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const LandingHeader: React.FC<ModalProps> = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const { data: communities } = useFindAllCommunities();
  const [cityState, setCityState] = useState<string>("");

  const router = useRouter();
  const { saveSearchInfo } = useContext(SearchContext) as SearchContextType;

  const onClickCity = () => {
    if (cityState.length > 0) {
      let urlParams = "?veeSearch=true";
      const city = communities?.find((city) => city.community === cityState);
      if (city == undefined) {
        const city2 = cities.find((city) => city.province === cityState);
        urlParams =
          urlParams +
          "&lat=" +
          city2?.latitude +
          "&lon=" +
          city2?.longitude +
          "&city=" +
          city2?.province +
          "&distance=" +
          city2?.radius;
        saveSearchInfo(city2);
      } else {
        urlParams =
          urlParams + "&community=" + city.id + "&city=" + city.community;

        saveSearchInfo(city);
      }
      router.push("/home" + urlParams);
    }
  };
  useEffect(() => {
    if (cityState != "") {
      onClickCity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityState]);

  const mounted = useFixHydration();

  if (!mounted) {
    return <Skeleton variant="rounded" height={465}></Skeleton>;
  }

  return (
    <HomeHeaderDiv
      style={{
        background: PRIMARY_BUTTON_COLOR,
        height: "372px",
        paddingTop: "30px",
      }}
      className="responsive-header"
    >
      <AbsoluteDiv
        className="hide-decorators"
        left="0px"
        style={{ height: "100%", width: "272px" }}
      >
        <Image
          style={{ marginTop: "10px", width: "auto", height: "95%" }}
          src={LeftLandingImage}
          width={0}
          height={0}
          alt="Left Header Decorator"
        />
      </AbsoluteDiv>
      <HorizontalCenterDiv
        width="100%"
        style={{
          height: "372px",
          flexDirection: "column",
          gap: "32px",
          textAlign: "center",
        }}
      >
        <Slogan />
        <CustomDiv
          className="search-init-landing"
          style={{ zIndex: 9, width: "50%" }}
        >
          <SearchInputWithIcon
            onClick={() => {
              setOpen(true);
            }}
            title={t("home.where")}
            subtitle={
              cityState.length > 0 ?
                cityState
              : t("activity.map.search_or_select")
            }
            height="65px"
          >
            <HexagonButton
              onClick={() => {
                setOpen(true);
              }}
              width="43px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
            >
              <Image
                alt="search"
                width="16"
                height="16"
                src={Search.src}
                className="search-landing-hexagon"
              />
            </HexagonButton>
          </SearchInputWithIcon>
        </CustomDiv>
        <AbsoluteDiv width="75%" bottom="0px" style={{ zIndex: -0 }}>
          <Image
            style={{ marginTop: "10px", width: "100%", height: "auto" }}
            src={VeeRoadDecorator}
            width={872}
            height={245}
            className="h-[0px]"
            alt="Vee Header Decorator"
            placeholder={"blur"}
            priority={true}
          />
        </AbsoluteDiv>
      </HorizontalCenterDiv>
      <AbsoluteDiv
        className="hide-decorators"
        right="-77px"
        style={{ height: "100%", width: "272px" }}
      >
        <Image
          style={{ marginTop: "10px", width: "auto", height: "95%" }}
          src={RightLandingDecorator}
          width={0}
          height={0}
          alt="Right Header Decorator"
          priority={true}
        />
      </AbsoluteDiv>

      {open && (
        <ModalSearchCity
          open={open}
          setOpen={setOpen}
          communities={communities as CityType[]}
          setCityState={setCityState}
        />
      )}
    </HomeHeaderDiv>
  );
};

export default LandingHeader;
